<template>
  <div class="row">
    <!--  导师信息  -->
    <div class="flex xs10 offset--xs1">
      <va-card title="申请导师">
        <div class="row">

          <div class="flex md6 sm6 xs12">
            <va-input
              label="申请导师性名"
              v-model="insertData.candidate.nickname"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.candidate.createTime"
              label="申请提交时间"
            />
          </div>
        </div>
      </va-card>
    </div>
    <!--  课程信息  -->
    <div class="flex xs10 offset--xs1">
      <va-card :title="title + serviceType">
        <div class="row">
          <div class="flex justify--center xs12">
            <va-button-group>
              <va-button outline class="mb-2" color="info" @click="approveModal=true" :disabled="!submitButtonStatus">
                通过申请
              </va-button>
              <va-button outline class="mb-2" color="danger" @click="rejectModal=true" :disabled="!submitButtonStatus">
                拒绝申请
              </va-button>
            </va-button-group>
          </div>
          <div class='flex md7 sm6 xs12' v-show="insertData.imgUrl.length!==0">
            <va-card
              overlay
              :image='insertData.imgUrl'
              class="va-card-image"
              title="头像"
              v-show="!isCreator"
            >
            </va-card>
          </div>
          <div class="flex md5 sm6 xs12" v-show="!isCreator">
            <va-tree-category isOpen label="已有导师">
              <va-tree-node v-for="mentor in mentors" :key="mentor.id">
                <div class="flex row align--center">
                  <va-input v-model="mentor.nickname" class="mb-0" disabled/>
                </div>
              </va-tree-node>
            </va-tree-category>
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              label='课程id'
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="课程名称"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.createTime"
              label="课程创建时间"
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.projectDescription"
              label="项目简介"
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.responsibility"
              label="工作职责"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-tree-category isOpen label="你将收获">
              <va-tree-node v-for="reward in insertData.willRewards" :key="reward.id">
                <div class="flex row align--center">
                  <va-input v-model="reward.reward" class="mb-0" disabled/>
                </div>
              </va-tree-node>
            </va-tree-category>
          </div>
          <div class="flex md6 sm6 xs12" v-show="!isCreator">
            <va-tree-category isOpen label="课程标签">
              <va-tree-node v-for="tag in courseTags" :key="tag.id">
                <div class="flex row align--center">
                  <va-input v-model="tag.name" class="mb-0" disabled/>
                </div>
              </va-tree-node>
            </va-tree-category>
          </div>
        </div>
        <div class="row justify--center">
          <div class="flex md2">
            <va-button class="ma-0" color="gray" slot="trigger" @click="$router.push({ name: 'listAuditingCourse' })" :disabled="!submitButtonStatus">
              返回
            </va-button>
          </div>
        </div>
        <va-modal
          v-model="rejectModal"
          title="拒绝申请"
          okText="提交"
          position="center"
          message="请再次确认是否要拒绝？"
          @ok="confirmReject"
        />
        <va-modal
          v-model="approveModal"
          title="通过申请"
          okText="提交"
          position="center"
          message="请再次确认是否要通过？"
          @ok="confirmApprove"
        />
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { computeServiceType, copyObject, formatTime } from '@/utils/common'
import auditingCourseApi from '../../../api/auditingCourse'
import { COURSE_TYPE, COURSE_TYPES, SERVICE_AUDIT_TYPES } from '@/utils/constants'
export default {
  data () {
    return {
      insertData: {
        serviceMtmMentorId: null,
        id: null,
        name: '',
        imgUrl: '',
        projectDescription: '',
        responsibility: '',
        isCreator: null,
        auditStatus: null,
        status: null,
        createTime: '',
        creatorUid: '',
        willRewards: [],
        candidate: {},
      },
      courseTags: [],
      mentors: [],
      isCreator: false,
      status: null,
      title: '申请加入',
      submitButtonStatus: true,
      auditTypes: SERVICE_AUDIT_TYPES,
      approveModal: false,
      rejectModal: false,
      serviceType: null,
    }
  },
  created () {
    this.getAuditingEnterpriseToOne()
  },
  computed: {
  },
  methods: {
    getAuditingEnterpriseToOne () {
      const params = this.$route.query
      auditingCourseApi.getAuditingEnterpriseToOne(params.serviceId, params).then(response => {
        copyObject(response.auditingEnterpriseToOne, this.insertData)
        this.insertData.createTime = formatTime(this.insertData.createTime)
        this.insertData.candidate.createTime = formatTime(this.insertData.candidate.createTime)
        this.courseTags = response.courseTags
        this.mentors = response.mentors
        this.isCreator = this.insertData.isCreator
        if (this.insertData.isCreator) {
          this.title = '申请创建'
        }
        this.serviceType = computeServiceType(parseInt(params.serviceType)).text
      }).catch(error => alert(error))
    },
    resetStatus () {
      this.status = null
    },

    processCourse (auditStatus) {
      this.changeButtonStatus(false)
      const data = {
        serviceId: this.insertData.id,
        serviceMtmMentorId: this.insertData.serviceMtmMentorId,
        auditStatus: auditStatus,
      }
      if (this.insertData.id != null) {
        auditingCourseApi.processAuditingEnterpriseToOne(data.serviceId, data).then(response => {
          if (response.success === true) {
            this.changeButtonStatus(true)
            if (auditStatus === this.auditTypes.APPROVED.CODE) {
              this.showToast('审核通过，请确认课程信息', {
                duration: 6000,
                icon: 'fa-success',
                position: 'top-center',
                fullWidth: false,
              })
              this.$router.push({ path: `/admin/services/updateEnterpriseToOne/${data.serviceId}` })
            } else {
              this.showToast('更新成功', {
                duration: 1000,
                icon: 'fa-success',
                position: 'top-center',
                fullWidth: false,
              })
              this.$router.push({ name: 'listAuditingCourse' })
            }
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
        this.rejectModal = false
        this.approveModal = false
      }
      this.resetStatus()
    },
    clickCancel () {
    },
    checkField () {
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    confirmApprove () {
      this.processCourse(this.auditTypes.APPROVED.CODE)
    },
    confirmReject () {
      this.processCourse(this.auditTypes.REJECTED.CODE)
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
